import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';

import { Button, TextField } from '../../atoms';
import AddIcon from '../../icons/Add';

export interface ActionProps {
  fullWidth?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  actionField: {
    display: 'flex',
    height: '3rem',
    padding: 0,
    '& [class*="MuiFormControl-root"]': {
      flexDirection: 'row',
      marginRight: theme.spacing(1),
    },
  },
  fullWidth: {
    flexDirection: 'column',
    '& [class*="MuiFormControl-root"]': {
      margin: theme.spacing(0, 0, 1),
    },
  },
}));

export const ActionField = (props: ActionProps): JSX.Element => {
  const { fullWidth = false } = props;

  const classes = useStyles();
  const actionFieldStyles = clsx(
    classes.actionField,
    fullWidth === true && classes.fullWidth,
  );

  return (
    <div className={actionFieldStyles}>
      <TextField endIcon={<AddIcon />} />
      <Button>Button</Button>
    </div>
  );
};
